import { getSiteCurrencyISO, SiteCurrency } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { ISignUpTrackingData } from './models/ISignUpTrackingData'

export function followStory() {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.FOLLOW_STORY, getFollowStoryDetails())
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

function getFollowStoryDetails(): ISignUpTrackingData {
  const state: AppState = Object.assign({}, store.getState())

  return {
    value: 1,
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    country: state.locale.country,
    trip_id: 50,
    name: 'follow',
    category: 'story',
  }
}

export function FacebookFollowStory(data: ISignUpTrackingData) {
  return {
    value: data.value,
    currency: data.currency,
    country: data.country,
    content_id: data.trip_id,
    content_name: data.name,
    content_category: data.category,
  }
}

export function GoogleFollowStory(data: ISignUpTrackingData) {
  return {
    event_category: data.category,
  }
}
